module.exports = __webpack_public_path__ + "files/409e5045b5864ba9254118f19cedbecf.png";


/*****************
 ** WEBPACK FOOTER
 ** ./images/icons/word.png
 ** module id = 387
 ** module chunks = 0
 **/